<script lang="ts">
  import { Accordion, AccordionItem } from "sveltestrap";
  import type { Diligence } from "../../../Model/Diligence";
  import AllListDataComplainants from "../../AllListDataComplainants.svelte";
  import type { Third } from "../../../Model/Third";
  import { complainantService, denouncedService, witnessService } from "../../../services";
  import AddThirdModal from "../../AddThirdModal.svelte";
  import DiligenceWitnessData from "../Global/DiligenceWitnessData.svelte";
  import PoliceManifestationFinishForm from "../Global/PoliceManifestationFinishForm.svelte";
  import DiligenceComplainantLostData from "./Data/DiligenceComplainantLostData.svelte";
  import DiligenceDenouncedLostData from "./Data/DiligenceDenouncedLostData.svelte";
  import FilesList from "../../FilesList.svelte";
  import PoliceManifestationInitialForm from "../Global/PoliceManifestationInitialForm.svelte";

  export let diligence: Diligence;

  type ThirdType = 'complainant' | 'denounced' | 'witness';

  let complainantsThirds: Third[] = [];
  let complainantThird: Third;
  let complainantThirdId: string = '';

  let denouncedsThirds: Third[] = [];
  let denouncedThird: Third;
  let denouncedThirdId: string = '';

  let witnesssThirds: Third[] = [];
  let witnessThird: Third;
  let witnessThirdId: string = '';

  let openModal = false;
  let openComplainantModal = false;
  let openDenouncedModal = false;
  let openWitnessModal = false;


  let onChangeThird: (event: CustomEvent<Third>) => Promise<void> = async () => {};

  $: loadForm(diligence);

  async function loadForm(diligence){
    await Promise.all([ 
        loadComplainats(diligence),
        loadDenounceds(diligence),
        loadWitness(diligence)
      ]) 
  }

  async function loadComplainats(diligence){
    let opts = {
        offset : 0,
        limit : 25,
        filters: {
            diligenceId: diligence.id,
        }
    }

    complainantsThirds = await complainantService.findLostThirds(opts);
    complainantsThirds.sort((a,b) => {
        return a.name < b.name ? -1 : 1;
    })
  }

  async function saveNewComplainantActa({ detail: third }: CustomEvent<Third>){
    await complainantService.createComplainant(third.id, diligence.id);
    complainantsThirds.push(third);
    complainantsThirds = complainantsThirds;
  }

  async function openComplaintModal({detail}: CustomEvent<Third>){
    complainantThird = complainantsThirds.find(c => c.id == detail.id)
    if (complainantThird) {
      complainantThirdId = detail.id
      openComplainantModal = true
    }
  }

  async function loadDenounceds(diligence){
    let opts = {
        offset : 0,
        limit : 25,
        filters: {
            diligenceId: diligence.id,
        }
    }

    denouncedsThirds = await denouncedService.findLostThirds(opts);
    denouncedsThirds.sort((a,b) => {
        return a.name < b.name ? -1 : 1;
    })
  }

  async function saveNewDenouncedActa({ detail: third }: CustomEvent<Third>){
    await denouncedService.createDenounced(third.id, diligence.id);
    denouncedsThirds.push(third);
    denouncedsThirds = denouncedsThirds;
  }

  async function openActionDenouncedModal({detail}: CustomEvent<Third>){
    denouncedThird = denouncedsThirds.find(c => c.id == detail.id)
    if (denouncedThird) {
      denouncedThirdId = detail.id
      openDenouncedModal = true
    }
  }


  async function loadWitness(diligence){
  
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }

  witnesssThirds = await witnessService.findThirds(opts);
  witnesssThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
  }

  async function saveNewWitnessActa({ detail: third }: CustomEvent<Third>){
        await witnessService.createWitness(third.id, diligence.id);
        witnesssThirds.push(third);
        witnesssThirds = witnesssThirds;
  }


  async function openActionWitnessModal({detail}: CustomEvent<Third>){
    witnessThird = witnesssThirds.find(c => c.id == detail.id)
    if (witnessThird) {
      witnessThirdId = detail.id
      openWitnessModal = true
    }
  }

  async function onAddNewThird(type: ThirdType){
    switch (type) {
      case 'complainant':
        onChangeThird = saveNewComplainantActa;
      break;
      case 'denounced':
        onChangeThird = saveNewDenouncedActa;
      break;
      case 'witness':
        onChangeThird = saveNewWitnessActa;
      break;
      default:
        throw new Error(`Error al obtener el type a guardar`);
    }

    openModal = true
  }

  function toggle() {
    openModal = !openModal;
  }
  function toggleComplainantModal(){
    openComplainantModal = !openComplainantModal
  }

  function toggleDenouncedModal(){
    openDenouncedModal = !openDenouncedModal
  }

  function toggleWitnessModal(){
    openWitnessModal = !openWitnessModal
  }

  function saveComplainant(){
    loadForm(diligence);
  }

  async function deleteComplaiant(event) {

    await complainantService.deleteComplainantGlobal(event.detail);

    loadComplainats(diligence)
  }

  async function deleteDenounced(event) {

    await denouncedService.deleteDenouncedGlobal(event.detail);

    loadDenounceds(diligence)
  }

  async function deleteWitness(event) {
    await witnessService.deleteWitness(event.detail);

    loadWitness(diligence)
  }
</script>




<Accordion>
  <AccordionItem header="Manifestación Policial Inicial">
    <PoliceManifestationInitialForm {diligence} />
  </AccordionItem>
  <AccordionItem header="Denunciante">
      <AllListDataComplainants thirds={complainantsThirds} on:editThird={openComplaintModal} on:newThird={() => onAddNewThird('complainant')} on:deleteComplainant={deleteComplaiant}/>
  </AccordionItem>
  <AccordionItem header="Denunciado">
      <AllListDataComplainants thirds={denouncedsThirds} on:editThird={openActionDenouncedModal} on:newThird={() => onAddNewThird('denounced')} on:deleteComplainant={deleteDenounced}/>
  </AccordionItem>
 <AccordionItem header="Testigos">
      <AllListDataComplainants thirds={witnesssThirds} on:editThird={openActionWitnessModal} on:newThird={() => onAddNewThird('witness')} on:deleteComplainant={deleteWitness}/>
  </AccordionItem>
  <AccordionItem header="Manifestación Policial Final">
    <PoliceManifestationFinishForm {diligence} />
  </AccordionItem>
  <AccordionItem header="Archivos">
    <FilesList contextId={diligence.id}/>
  </AccordionItem>
</Accordion>

<AddThirdModal
  open={openModal}
  {toggle}
  thirdId={complainantThirdId}
  on:changeThird={onChangeThird}
/>

<DiligenceComplainantLostData
  open={openComplainantModal}
  toggle={toggleComplainantModal}
  complainantThird={complainantThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceDenouncedLostData
  open={openDenouncedModal}
  toggle={toggleDenouncedModal}
  denouncedThird={denouncedThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceWitnessData
  open={openWitnessModal}
  toggle={toggleWitnessModal}
  witnessThird={witnessThird} 
  diligenceId={diligence.id} 
  on:saveWitness={(event) => saveComplainant()}
/>

  <style lang="scss">

    :global(.accordion){
      padding-right: 3px !important;
      padding-left: 3px !important;
    }
  
    :global(.accordion-item){
      border: 1px solid #dee2e6 !important;
      border-radius: 0.25rem !important;
    }
  
  
  </style>